import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ onLoaded }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Simulate loading progress
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + Math.random() * 15;
      });
    }, 150);

    // Minimum show time
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        if (onLoaded) onLoaded();
      }, 800); // Match fade out duration
    }, 2500);

    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, [onLoaded]);

  if (!isVisible) return null;

  return (
    <div className="golden-loading-screen">
      {/* Background with gradient */}
      <div className="loading-background"></div>
      
      {/* Golden Orb Animation */}
      <div className="golden-orb">
        <div className="outer-ring"></div>
        <div className="inner-ring"></div>
        <img 
          src="/logo3.png" 
          alt="Golden Nest Hotel GH" 
          className="center-logo"
          onError={(e) => {
            e.target.style.display = 'none';
            // Show fallback text
            const fallback = document.createElement('div');
            fallback.className = 'logo-fallback';
            fallback.textContent = '🏨';
            e.target.parentNode.appendChild(fallback);
          }}
        />
      </div>
      
      {/* Hotel Name with Gold Shimmer */}
      <h1 className="hotel-name">
        Golden Nest Hotel GH
      </h1>
      
      {/* Tagline */}
      <p className="tagline">
        Luxury Redefined
      </p>
      
      {/* Loading Progress Bar */}
      <div className="progress-container">
        <div 
          className="progress-bar" 
          style={{ width: `${Math.min(progress, 100)}%` }}
        ></div>
      </div>
      
      {/* Loading Text */}
      <p className="loading-text">
        Preparing your luxury experience... {Math.round(progress)}%
      </p>
      
      {/* Golden Particles */}
      <div className="particles">
        <div className="particle particle-1"></div>
        <div className="particle particle-2"></div>
        <div className="particle particle-3"></div>
        <div className="particle particle-4"></div>
        <div className="particle particle-5"></div>
      </div>
      
      {/* Skip Button for Users */}
      <button 
        className="skip-button"
        onClick={() => {
          setIsVisible(false);
          if (onLoaded) onLoaded();
        }}
      >
        Enter Site
      </button>
    </div>
  );
};

export default LoadingScreen;